import SourceFilter from "../../../../components/filters/SourceFilter.jsx";
import CampaignFilter from "../../../../components/filters/CampaignFilter.jsx";
import DateRangePicker from "../../../../components/DateRangePicker.jsx";
import React from "react";
import UpdateDropdown from "../../../../components/dashboard/UpdateDropdown.jsx";

export default function LeadDashboardFilters({hideSourceFilter, hideCampaignFilter}) {

    return (
        <div className={'flex-wrap items-center justify-center md:justify-end filter-btn flex gap-1 flex-wrap sm:justify-end pr-4 md:pr-0'}>
            <UpdateDropdown/>
            {!hideSourceFilter && <SourceFilter/>}
            {!hideCampaignFilter && <CampaignFilter/>}
            <DateRangePicker/>
        </div>
    );
}
